import { render, staticRenderFns } from "./PDFUploader.vue?vue&type=template&id=f009abf6&scoped=true&"
import script from "./PDFUploader.vue?vue&type=script&lang=js&"
export * from "./PDFUploader.vue?vue&type=script&lang=js&"
import style0 from "./PDFUploader.vue?vue&type=style&index=0&id=f009abf6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f009abf6",
  null
  
)

export default component.exports